import React, { useCallback } from 'react';
import {    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    email,
    choices,
    Edit, SimpleForm, TextInput,SelectInput,
    DateInput, BooleanInput, NumberInput,ReferenceInput,
    ImageInput, ImageField, SaveButton, Toolbar, DeleteButton,AutocompleteInput
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
    subjectid:{
        display:'inline-block'
    }, 
    title: {
        display:'inline-block',
        marginLeft: '20px',
        width:'300px'
    }
}));

export const DistrictEdit = props => {
    const classes = useStyles({});
    return (
        <Edit {...props} title="District">
            <SimpleForm redirect="list"   
            variant="outlined">
            <TextInput validate={required()} source="code" label="District Code" fullWidth={true} />
            <TextInput validate={required()} source="name" label="District Name" fullWidth={true} />
            
                        <ReferenceInput variant="outlined" label="State" source="stateId"
                                        reference="states" perPage={500}
                                       
                                        validate={required()} 
                                        sort={{ field: 'name', order: 'ASC' }}
                                        shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}
                                        fullWidth={true} > 
                                        <AutocompleteInput validate={required()} optionText="name" variant="outlined"
                                         shouldRenderSuggestions={(val) => { return val && val.trim().length >= 1 }}  fullWidth={true}  
                                         />
                                    </ReferenceInput>
            <BooleanInput initialValue={true} source="isActive" />
            </SimpleForm>
        </Edit>
    );
}